/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbMobileRefineMenuFilterCategory_filters$ref = any;
type SbMobileRefineMenuFilterDimensions_filters$ref = any;
type SbRespRefineMenuFilterCategory_filters$ref = any;
type SbRespRefineMenuFilterDimensions_filters$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedRefineMenuFilters_filters$ref: FragmentReference;
export type SbSharedRefineMenuFilters_filters = $ReadOnlyArray<{|
  +name: ?string,
  +totalCount: ?number,
  +localizedFilterName: ?string,
  +values: ?$ReadOnlyArray<?{|
    +displayName: ?string,
    +urlLabel: ?string,
    +count: ?number,
    +code: ?string,
    +link: ?string,
    +hexCode: ?string,
    +stats: ?$ReadOnlyArray<?{|
      +key: ?string,
      +values: ?string,
    |}>,
  |}>,
  +$fragmentRefs: SbRespRefineMenuFilterCategory_filters$ref & SbMobileRefineMenuFilterCategory_filters$ref & SbRespRefineMenuFilterDimensions_filters$ref & SbMobileRefineMenuFilterDimensions_filters$ref,
  +$refType: SbSharedRefineMenuFilters_filters$ref,
|}>;
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilters_filters",
  "type": "SearchBrowseFilter",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "totalCount",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "localizedFilterName",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterCategory_filters",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterCategory_filters",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterDimensions_filters",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterDimensions_filters",
      "args": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "values",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchBrowseFilterValue",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "displayName",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "urlLabel",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "count",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "code",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "link",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "hexCode",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "stats",
          "storageKey": null,
          "args": null,
          "concreteType": "stats",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "key",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "values",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '78d6fdfb0e38a47662d65bc610bb02d5';
module.exports = node;
